import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ConnectorService = /** @class */ (function () {
    function ConnectorService(httpClient) {
        this.httpClient = httpClient;
        this.getOnsetExamDataCompleted = new EventEmitter();
        this.postOnsetExamResultCompleted = new EventEmitter();
    }
    ConnectorService.prototype.getOnsetExamData = function (token, env) {
        var _this = this;
        var envParam = '';
        if (env && (env === 'staging' || env === 'develop')) {
            envParam = "/?env=" + env;
        }
        this.httpClient
            .get(environment.apiUrl + 'connector' + '/' + 'onset' + '/' + token + envParam)
            .subscribe(function (res) { _this.getOnsetExamDataCompleted.emit(res); }, function (err) {
            console.log(err.error);
            console.log(err.name);
            console.log(err.message);
            console.log(err.status);
            _this.getOnsetExamDataCompleted.emit(null);
        });
    };
    ConnectorService.prototype.postOnsetExamResult = function (token, onsetExamResultDto, env) {
        var _this = this;
        var envParam = '';
        if (env && (env === 'staging' || env === 'develop')) {
            envParam = "/?env=" + env;
        }
        this.httpClient
            .post(environment.apiUrl + 'connector' + '/' + 'onset' + '/' + token + '/' + 'results' + envParam, onsetExamResultDto)
            .subscribe(function (res) { _this.postOnsetExamResultCompleted.emit(res); }, function (err) {
            console.log(err.error);
            console.log(err.name);
            console.log(err.message);
            console.log(err.status);
        });
    };
    ConnectorService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            console.error(error);
            console.log(operation + " failed: " + error.message);
            return of(result);
        };
    };
    ConnectorService.ngInjectableDef = i0.defineInjectable({ factory: function ConnectorService_Factory() { return new ConnectorService(i0.inject(i1.HttpClient)); }, token: ConnectorService, providedIn: "root" });
    return ConnectorService;
}());
export { ConnectorService };
